export default __webpack_public_path__ + "static/media/howItWorksClient3.42966f82.png";